/* RT Product Feed gate — the JS half of snippets/fyre-rt-feed-visible.liquid.
   Both halves must agree: any client-side surface that rebuilds variant choices (fyre-pdp.js, fyre-resolve.js)
   would otherwise re-expose the B2B/Hidden SKUs Liquid just filtered out. */
(function () {
  'use strict';

  // Feed values arrive either as a JSON-array string (Shopify list metafield, e.g. '["B2B","DTC"]') or as plain
  // comma-separated text — the metafield definition differs per surface, so both shapes must parse here.
  function parse(value) {
    if (value == null) return [];
    var list = null;
    if (Array.isArray(value)) {
      list = value;
    } else {
      var s = String(value).trim();
      if (s.charAt(0) === '[') {
        try {
          var decoded = JSON.parse(s);
          if (Array.isArray(decoded)) list = decoded;
        } catch (e) { /* not JSON after all — fall through to the comma split */ }
      }
      if (!list) list = s.split(',');
    }
    var out = [];
    list.forEach(function (t) {
      var token = String(t == null ? '' : t).trim().toLowerCase();
      if (token) out.push(token);
    });
    return out;
  }

  // A variant with no feed of its own inherits the product's; with neither, it HIDES. The feed is the sitewide
  // authority on who a SKU is offered to, so an unclassified SKU is offered to nobody rather than to everyone —
  // every variant must carry a feed before deploy. A DEFINED but empty feed hides for the same reason.
  function visible(variantFeedValue, productFeedValue, isB2B) {
    var raw = variantFeedValue == null ? productFeedValue : variantFeedValue;
    if (raw == null) return false;
    var tokens = parse(raw);
    if (tokens.indexOf('dtc') !== -1) return true;
    if (tokens.indexOf('b2b') !== -1) return !!isB2B;
    return false;
  }

  window.FyreRtFeed = { parse: parse, visible: visible };
})();
